import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  DtpTable,
  DtpTableHeader,
  DtpNoContent,
} from 'dtp-react-components';
import { ExportToCsv } from 'export-to-csv';
import {
  Button,
} from '../../components/index';
import {
  doPost,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';

class SimulacaoCompensacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNoContent: false,
      noContentPrimaryMessage: null,
      noContentSecondaryMessage: null,
      legendaRelatorio: null,
    };
  }

  gerarCsv = (lista) => {
    if (lista && lista !== undefined && lista.length > 0) {
      const csvExporter = new ExportToCsv({
        filename: 'relatorio',
        fieldSeparator: ';',
        showTitle: true,
        title: this.state.legendaRelatorio,
        showLabels: true,
        headers: this.props.headers,
      });
      csvExporter.generateCsv(lista);
    }
  };

  // FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
  formatarColuna = (cell, tipo) => {
    let valor = cell;
    const cellDataPreenchida = (cell !== null && cell !== '' && cell !== undefined);
    if (tipo === 'numero') {
      valor = new Intl.NumberFormat('pt-BR').format(cell);
    } else if (tipo === 'moeda') {
      valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).formatToParts(cell).map(({ type, value }) => {
        switch (type) {
          case 'currency': return '';
          default: return value;
        }
      }).reduce((string, part) => string + part);
    } else if (tipo === 'cpf') {
      valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (tipo === 'cnpj') {
      valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else if (tipo === 'nit') {
      if (Number.isInteger(cell)) {
        valor = cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
      } else {
        valor = cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
      }
    } else if (tipo === 'protocolo') {
      valor = `'${cell}`;
    } else if (cellDataPreenchida) {
      if (cell !== null && cell !== undefined) {
        valor = moment(cell).format('DD/MM/YYYY');
      }
    }
    return valor.trim();
  }

prepararColunasExportacao = (data, colunas) => {
  const dados = data.map((item) => {
    const linha = Object.assign({}, item);
    colunas.forEach((c) => {
      const key = Object.keys(item)[c.index];
      const coluna = item[key];
      const colunaFormatada = this.formatarColuna(coluna, c.tipo);
      linha[key] = colunaFormatada;
    });
    return linha;
  });
  return dados;
}

pesquisarColunaJson = (json, coluna) => {
  let retorno = json[coluna];
  if (retorno === undefined) {
    retorno = '';
  }
  return retorno;
}

listaColunasFormatar = [
  { index: 2, tipo: 'moeda' },
  { index: 3, tipo: 'moeda' },
  { index: 4, tipo: 'moeda' },
  { index: 5, tipo: 'moeda' },
];

listaColunasRequerimentoFormatar = [
  { index: 1, tipo: 'protocolo' },
  { index: 4, tipo: 'cpf' },
  { index: 11, tipo: 'moeda' },
  { index: 12, tipo: 'moeda' },
  { index: 13, tipo: 'moeda' },
  { index: 14, tipo: 'moeda' },
  { index: 15, tipo: 'moeda' },
  { index: 16, tipo: 'moeda' },
  { index: 17, tipo: 'moeda' },
  { index: 18, tipo: 'moeda' },
  { index: 19, tipo: 'moeda' },
  { index: 20, tipo: 'moeda' },
  { index: 21, tipo: 'moeda' },
  { index: 22, tipo: 'data' },
  { index: 23, tipo: 'data' },
  { index: 24, tipo: 'data' },
  { index: 25, tipo: 'data' },
];

listaColunasRequerimentoNaoAptoFormatar = [
  { index: 2, tipo: 'protocolo' },
  { index: 3, tipo: 'cpf' },
];

extrairColunasJson = (data) => {
  let objetoLinha = {};
  const dados = data.map((item) => {
    const objDestinatario = `${item[Object.keys(item)[1]]}-${item[Object.keys(item)[0]]}`;
    const objSolicitante = `${item[Object.keys(item)[3]]}-${item[Object.keys(item)[2]]}`;
    objetoLinha = {
      solicitante: objSolicitante,
      destinatario: objDestinatario,
      valorEstoque: this.pesquisarColunaJson(item, 'valorEstoque'),
      valorFluxoAcumulado: this.pesquisarColunaJson(item, 'valorFluxoAcumulado'),
      valorFluxo: this.pesquisarColunaJson(item, 'valorFluxo'),
      valorTotal: this.pesquisarColunaJson(item, 'valorTotal'),
    };
    return objetoLinha;
  });
  return dados;
}

extrairColunasListaRequerimentosJson = (data) => {
  let objetoLinha = {};
  const dados = data.map((item) => {
    objetoLinha = {
      nomeBeneficiario: this.pesquisarColunaJson(item, 'nomeBeneficiario'),
      idProtocolo: this.pesquisarColunaJson(item, 'idProtocolo'),
      solicitante: `${this.pesquisarColunaJson(item, 'nomeSolicitante')} - ${this.pesquisarColunaJson(item, 'idSolicitante')}`,
      destinatario: `${this.pesquisarColunaJson(item, 'nomeDestinatario')} - ${this.pesquisarColunaJson(item, 'idDestinatario')}`,
      idCpf: this.pesquisarColunaJson(item, 'idCpf'),
      matricula: this.pesquisarColunaJson(item, 'matricula'),
      estado: this.addTipoEstadoLabel(this.pesquisarColunaJson(item, 'estado')),
      tipoRequerimento: this.pesquisarColunaJson(item, 'tipoRequerimento'),
      tipoAposentadoria: this.pesquisarColunaJson(item, 'tipoAposentadoria'),
      numeroBeneficio: this.pesquisarColunaJson(item, 'numeroBeneficio'),
      tipoProRataInicial: this.addTipoProRataInicialLabel(this.pesquisarColunaJson(item, 'tipoProRataInicial')),
      valorProRataMensal: this.pesquisarColunaJson(item, 'valorProRataMensal'),
      valorEstoque: this.pesquisarColunaJson(item, 'valorEstoque'),
      valor13Estoque: this.pesquisarColunaJson(item, 'valor13Estoque'),
      valorTotalEstoque: this.pesquisarColunaJson(item, 'valorTotalEstoque'),
      valorFluxo: this.pesquisarColunaJson(item, 'valorFluxo'),
      valor13Fluxo: this.pesquisarColunaJson(item, 'valor13Fluxo'),
      valorTotalFluxo: this.pesquisarColunaJson(item, 'valorTotalFluxo'),
      valorFluxoAcumulado: this.pesquisarColunaJson(item, 'valorFluxoAcumulado'),
      valor13FluxoAcumuladorFluxo: this.pesquisarColunaJson(item, 'valor13FluxoAcumuladorFluxo'),
      valorTotalFluxoAcumulado: this.pesquisarColunaJson(item, 'valorTotalFluxoAcumulado'),
      valorTotalRequerimento: this.pesquisarColunaJson(item, 'valorTotalRequerimento'),
      dataInicioFluxoAcumulado: this.pesquisarColunaJson(item, 'dataInicioFluxoAcumulado'),
      dataFimFluxoAcumulado: this.pesquisarColunaJson(item, 'dataFimFluxoAcumulado'),
      dataInicioEstoque: this.pesquisarColunaJson(item, 'dataInicioEstoque'),
      dataFimEstoque: this.pesquisarColunaJson(item, 'dataFimEstoque'),
    };
    return objetoLinha;
  });
  return dados;
}

addTipoEstadoLabel = tipo => (
  listUtils.getObject(listUtils.tiposEstado, tipo).label
)

addTipoProRataInicialLabel = (tipo) => {
  let retorno = '';
  if (tipo && tipo !== null) {
    retorno = listUtils.getObject(listUtils.tiposProRataInicial, tipo).label;
  }
  return retorno;
};

extrairColunasJsonNaoApto = (data) => {
  let objetoLinha = {};
  const dados = data.map((item) => {
    const objDestinatario = `${item[Object.keys(item)[5]]}-${item[Object.keys(item)[4]]}`;
    const objSolicitante = `${item[Object.keys(item)[3]]}-${item[Object.keys(item)[2]]}`;
    objetoLinha = {
      solicitante: objSolicitante,
      destinatario: objDestinatario,
      idProtocolo: this.pesquisarColunaJson(item, 'idProtocolo'),
      cpf: this.pesquisarColunaJson(item, 'idCpf'),
      tipoRequerimento: this.pesquisarColunaJson(item, 'tipoRequerimento'),
      motivoNaoAptidao: this.pesquisarColunaJson(item, 'motivoNaoAptidao'),
      estado: this.addTipoEstadoLabel(this.pesquisarColunaJson(item, 'estado')),
    };
    return objetoLinha;
  });
  return dados;
}

// tratarSucessoListaExportacao = () => {
//   if (this.props.data && this.props.data.length > 0) {
//     this.setState({
//     }, this.gerarCsv(this.props.data));
//   }
// };

tratarSucessoListaExportacao = (response) => {
  if (response.data !== '') {
    let lista = [];
    let dadosFormatados = [];
    if (response.data.nivel === undefined) {
      // consulta de requerimentos nao aptos
      lista = this.extrairColunasJsonNaoApto(response.data);
      dadosFormatados = this.prepararColunasExportacao(lista, this.listaColunasRequerimentoNaoAptoFormatar);
    } else if (response.data.nivel !== undefined) {
      if (response.data.nivel === 1) {
        lista = this.extrairColunasJson(response.data.simulacoes);
        dadosFormatados = this.prepararColunasExportacao(lista, this.listaColunasFormatar);
      } else {
        lista = this.extrairColunasListaRequerimentosJson(response.data.requerimentos);
        dadosFormatados = this.prepararColunasExportacao(lista, this.listaColunasRequerimentoFormatar);
      }
    }

    this.setState({
    }, this.gerarCsv(dadosFormatados));
  }
};

tratarErro = () => {
  const mensagemPrimaria = 'Não foi possível consultar os requerimentos.';
  const mensagemSecundaria = 'Contate o administrador do sistema.';
  this.setState({
    showNoContent: true,
    noContentPrimaryMessage: mensagemPrimaria,
    noContentSecondaryMessage: mensagemSecundaria,
  });
};

preparaRequest = (url, parametros) => {
  doPost(
    url,
    parametros,
    this.tratarSucessoListaExportacao,
    this.tratarErro,
  );
};

exportarCsv = (props) => {
  this.setState({
    legendaRelatorio: props.legendExportacao,
  });
  if (props.urlExportacao && props.parametrosExportacao) {
    const parametros = props.parametrosExportacao;
    parametros['start-position'] = 0;
    parametros['max-results'] = 100000;
    this.preparaRequest(props.urlExportacao, parametros);
  }
};

render() {
  if (this.state.showNoContent) {
    return (
      <DtpNoContent
        primaryText={this.state.noContentPrimaryMessage}
        secondaryText={this.state.noContentSecondaryMessage}
        show={this.state.showNoContent}
      />);
  }
  return (
    <React.Fragment>
      {this.props.nomeRelatorio !== '' ? (
        <React.Fragment>
          {this.props.data && this.props.data.length > 0 && (
            <Button
              hint="Exportar para CSV"
              onClick={() => { this.exportarCsv(this.props); }}
              icon="ico-doc-sheet"
              mini
            />
            )
          }
          {this.props.exibirBotaoVoltar ? (
            <Button
              hint="Voltar"
              icon="ico-arrow-curve-left"
              mini
              onClick={() => this.props.voltarAction()}
            />) : null
          }
          <div
            className={this.props.exibirBotaoVoltar ? 'relatorio' : ''}
            style={{ '--relatorioWidth': this.props.containerStyle.width }}
          >
            <DtpTable {...this.props}>
              {this.props.headers.map((item, i) => (
                <DtpTableHeader
                  key={item}
                  dataField={this.props.data[0] ? Object.keys(this.props.data[0])[i] : 'default'}
                  dataAlign="center"
                  isKey={i === 0}
                  header={item}
                  tdStyle={{ wordBreak: 'break-word' }}
                  dataFormat={this.props.dataFormatOptions[i]}
                  hidden={this.props.options.hidden && this.props.options.hidden.includes(i)}
                />))}
            </DtpTable>
          </div>
        </React.Fragment>
      ) : null
      }
    </React.Fragment>
  );
}
}

SimulacaoCompensacao.propTypes = {
  dataFormatOptions: PropTypes.object,
  voltarAction: PropTypes.func,
  exibirBotaoVoltar: PropTypes.bool,
}.isRequired;

SimulacaoCompensacao.defaultProps = {
  voltarAction: () => null,
};

export default SimulacaoCompensacao;



// WEBPACK FOOTER //
// ./src/pages/relatorios/SimulacaoCompensacao.jsx